import React from 'react'

export default function About() {
    return (
        <div>
            <h1>about</h1>
        </div>
    )
}
